module.exports = __webpack_public_path__ + "ac59bd1a7f14370c6cb1bd933dd55091.svg";